import React, { useEffect } from 'react';

import GolfTrips from '../components/content/golftrips/GolfTrips';
import MetaTags from '../components/meta/MetaTags';

function GolfTripsPage() {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.prerenderReady = true;
    }
  }, []);

  return (
    <div>
      <MetaTags
        title="Golf Holidays UK & Golf Breaks Trip Planner | GolfLists"
        description="Plan UK golf holidays, golf breaks and weekend breaks in England, Scotland, Wales and Ireland. Search by county, course or postcode and build your golf trip itinerary — free planner on GolfLists."
        imageUrl="https://stjbqlfgvlefqghlyumg.supabase.co/storage/v1/object/public/brand/GL_LOGO_300_302.png"
        url="https://golflists.com/lists/tools/golf-trips"
        keywords="golf holidays uk, golf breaks uk, golf weekend breaks uk, uk golf trip, golf trip planner, golf breaks england, golf holiday scotland, golf holidays scotland, weekend breaks uk, golf travel UK, GolfLists"
      />

      <div className="sm:overflow-y-scroll 3xl:min-h-[500px]">
        <GolfTrips />
      </div>
    </div>
  );
}

export default GolfTripsPage;
